import React, { SVGProps } from 'react'

/** Feature-local destructive-action glyph for the card actions menu. */
const SvgTrash = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <g fill={props.fill || 'currentColor'} fillRule="nonzero">
      <path d="M9.25 7.25V5a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75v2.25h3.75a.75.75 0 0 1 .14 1.487 1.764 1.764 0 0 1 .013.415l-.826 9.5a1.75 1.75 0 0 1-1.744 1.598H7.917a1.75 1.75 0 0 1-1.744-1.598l-.826-9.5a1.754 1.754 0 0 1 .013-.415.75.75 0 0 1 .14-1.487h3.75Zm1.5 0h2.5v-1.5h-2.5v1.5Zm-3.66 1.5a.25.25 0 0 0-.248.272l.826 9.5a.25.25 0 0 0 .249.228h8.166c.13 0 .238-.1.25-.228l.825-9.5a.25.25 0 0 0-.249-.272H7.091Z" />
      <path d="m10.448 16.694-.45-6a.75.75 0 1 0-1.496.112l.45 6a.75.75 0 1 0 1.496-.112zm2.302.056v-6a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0zm2.298.056.45-6a.75.75 0 1 0-1.496-.112l-.45 6a.75.75 0 1 0 1.496.112z" />
    </g>
  </svg>
)

export default SvgTrash
